import { withProfiler } from "@sentry/react";
import { StrictMode } from "react";

import type { Flipper } from "@shared/types/flipper";
import { ErrorBoundary, Providers } from "@unauthenticated/signupSignin/components";
import { OfficeSignUpPage as OfficeSignUpScene } from "@unauthenticated/signupSignin/scenes";

interface Props {
  emailRegex: string;
  currentCountry: string;
  flippers: Flipper[];
  ssoErrors?: string;
  roleId: string;
  roleType: "Practitioner" | "Clerk";
  roleAttributes?: any;
  storeId: string;
  e2e: boolean;
  analyticsAnonymousId: string;
}

const OfficeSignUpPage = ({
  emailRegex,
  currentCountry,
  flippers,
  ssoErrors,
  roleId,
  roleType,
  roleAttributes,
  storeId,
  e2e,
  analyticsAnonymousId,
}: Props) => {
  return (
    <StrictMode>
      <Providers
        emailRegex={emailRegex}
        currentCountry={currentCountry}
        flippers={flippers}
        e2e={e2e}
        analyticsAnonymousId={analyticsAnonymousId}
      >
        <ErrorBoundary {...{ flippers, roleId, storeId, roleType }}>
          <OfficeSignUpScene
            roleAttributes={roleAttributes}
            roleType={roleType}
            roleId={roleId}
            ssoErrors={ssoErrors}
          />
        </ErrorBoundary>
      </Providers>
    </StrictMode>
  );
};

const PatientInvitationPageWithProfiler = withProfiler(OfficeSignUpPage);
export { PatientInvitationPageWithProfiler as OfficeSignUpPage };
